import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import NotificationsTypeIcon from "site-apps/notifications/NotificationsTypeIcon";
import NotificationsResultIcon from "site-apps/notifications/NotificationsResultIcon";
import Moment from "moment";
import ConditionalRender from "../../components/ConditionalRender";

const MessageHeader = ({
    message,
    userLang = "es",
    onClickLink,
    onOpenProcessMonitor,
    showHr = true,
    disableDownload = false,
    hideDownload = false,
}) => {
    const texts = message.notify.texts;
    const title = texts[userLang].title;

    const isProcessNotification = () => {
        return message && message.notify.type === "p";
    };

    return (
        <div className="row">
            {showHr && <hr className="col-12" />}
            <div className="col">
                <h5 className="d-flex justify-content-between">
                    <div>{message.notify.sender}</div>
                    <div className="text-muted fs-09">{Moment(message.notify.created_at).format("DD/MM/YYYY HH:mm:ss")}</div>
                </h5>
            </div>

            <div className="col text-center" style={{maxWidth: "64px"}}>
                <NotificationsTypeIcon type={message.notify.type} />
                <NotificationsResultIcon result={message.notify.result} />
                <ConditionalRender condition={message.notify.url && !hideDownload}>
                    {disableDownload ? (
                        <span className="btn btn-link disabled" title="Vista previa">
                            <FontAwesomeIcon icon="download" />
                        </span>
                    ) : (
                        <button
                            className="btn btn-link"
                            type="button"
                            data-link={message.notify.url}
                            onClick={onClickLink}
                            title="Descargar archivo">
                            <FontAwesomeIcon icon="download" />
                        </button>
                    )}
                </ConditionalRender>
                {isProcessNotification() && (
                    <button
                        className="btn btn-link text-primary"
                        type="button"
                        onClick={onOpenProcessMonitor}
                        title="Ver monitor del proceso">
                        <FontAwesomeIcon icon="eye" />
                    </button>
                )}
            </div>
            <div className="col-12">
                <h6 className="mb-2">{title}</h6>
            </div>
            {showHr && <hr className="col-12" />}
        </div>
    );
};

export default MessageHeader;
